import React from 'react';

const AppFooter = props => {

    return React.createElement(
        "div",
        { className: "layout-footer" },
        React.createElement("div", { className: "footer-logo-container" }),
        React.createElement(
            "span",
            { className: "copyright" },
            "\xA9 ",
            process.env.REACT_APP_COMPANY_NAME
        )
    );
};

export default AppFooter;